import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Observable, finalize } from 'rxjs';

import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';

import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { IbanValidatorDao } from '@app/dao/iban-validator/iban-validator.dao';
import { UserService } from '@app/providers/user/user.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './rent-payment-iban.builder';

interface ProductType {
  type: FormControlOption[];
  name: string;
}

@UntilDestroy()
@Component({
    selector: 'rent-payment-iban',
    templateUrl: './rent-payment-iban.component.html',
    styleUrls: ['./rent-payment-iban.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RentPaymentIbanComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  // parameters: Parameters;
  pledge: PledgeRead;
  productsType$: Observable<any>;
  isModalOpen = false;
  accountId: string | number;
  ownerIds: number[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private ibanValidatorDao: IbanValidatorDao,
    private userService: UserService,
  ) {
    super(formConstructor);
  }

  @ViewChild('invalidIbanModal') invalidIbanModal: PrModalConfirmComponent;

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.pledge = this.subscriptionFacade.getPledge();

    const { accountId, owners } = this.pledge;
    this.accountId = accountId;
    this.ownerIds = _.compact(_.map(owners, 'ownerId'));
  }

  onSubmit() {
    this.form.markAsDirty();
    const { scpiRentPaymentIban } = this.form.value;
    this.ibanValidatorDao
      .validate(scpiRentPaymentIban)
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        if (!res.valid) {
          this.invalidIbanModal.open();
        } else {
          this.submitForm();
        }
      });
  }

  submitForm() {
    const payload = this.extract();

    const body = {
      ...payload.scpiRentPaymentIban,
      ownerIds: payload?.scpiRentPaymentIban?.ownerIds?.length
        ? payload.scpiRentPaymentIban.ownerIds
        : this.ownerIds,
      accountId: this.accountId,
    };

    this.userService
      .saveOwnerIban(this.accountId as number, body)
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.subscriptionFacade.submitPledge(this);
        }),
      )
      .subscribe();
  }

  onConfirmInvalidIban() {
    this.submitForm(); // Soumet le formulaire même si l'IBAN est invalide
  }

  onCancelInvalidIban() {
    this.invalidIbanModal.close(); // Ferme la modal, permettant à l'utilisateur de corriger
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
